<template>
  <div>
    <wc-page-title title='Dashboard'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <wc-data-box
            title='Reports'
            icon='mdi-report'
          >
            <v-card-text>
              <h3>Revenue Report</h3>
              <p>Provides a tally of all revenue generated between two dates.</p>
              <v-btn depressed class='primary' @click="$router.push({'name': 'RevenueReport'})">Open</v-btn>
              <v-divider class='my-4'></v-divider>
              <h3>Accounts Receivable Report</h3>
              <p>Provides dollar value of amounts owed as at a given date</p>
              <v-btn depressed class='primary' @click="$router.push({'name': 'AccountsReceivable'})">Open</v-btn>
              <v-divider class='my-4'></v-divider>
              <h3>SU & BD Revenue Report</h3>
              <p>Provides revenue totals for all startups or blowdowns for a given time frame.</p>
              <v-btn depressed class='primary' @click="$router.push({'name': 'SUBDRevenueReport'})">Open</v-btn>
            </v-card-text>
          </wc-data-box>
        </v-col>
        <v-col cols='12' md='4'>
          <wc-data-box
            title='New Fiscal Year'
          >
            <v-card-text>
              Beginning a new fiscal year will:<br>
              <ul>
                <li>Set new opening balances for all Balance Sheet accounts</li>
                <li>Roll all income and expense accounts into retained earnings</li>
                <li>Set all income and expnese accounts back to zero</li>
              </ul>
              <br>
              <v-btn
                @click='showDialog = true'
                color='warning'
                :disabled='!canStartNewYear'
              >Start New Fiscal Year</v-btn>
            </v-card-text>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>

    <wc-confirm
      title='Are you sure?'
      :showDialog='showDialog'
      @cancel='showDialog = false'
      @confirm='startNewFiscalYear'
    >
      Are you sure you are ready to start a new fiscal year?<br>
      <br>
      <wc-datepicker required v-model='new_fiscal_date'></wc-datepicker>
      <strong><u>This cannot be undone!</u></strong>
    </wc-confirm>
  </div>
</template>

<script>
import managementAPI from '@/api/management';

export default {
  name: 'management-dashboard',
  data: () => ({
    showDialog: false,
    new_fiscal_date: null
  }),
  computed: {
    canStartNewYear () {
      
      return true
    }
  },
  methods: {
    startNewFiscalYear(){
      if(this.new_fiscal_date === null){
        return;
      }
      managementAPI.setNewFiscalYear(this.new_fiscal_date);
      this.showDialog = false;
    }
  }
}
</script>
